"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leastPrecise = void 0;
const PackageFile_v0_8_1_1 = require("./PackageFile-v0.8.1");
function leastPrecise(a, b) {
    if (a === PackageFile_v0_8_1_1.CountPrecision.GREATER_THAN || b === PackageFile_v0_8_1_1.CountPrecision.GREATER_THAN)
        return PackageFile_v0_8_1_1.CountPrecision.GREATER_THAN;
    if (a === PackageFile_v0_8_1_1.CountPrecision.APPROXIMATE || b === PackageFile_v0_8_1_1.CountPrecision.APPROXIMATE)
        return PackageFile_v0_8_1_1.CountPrecision.APPROXIMATE;
    return PackageFile_v0_8_1_1.CountPrecision.EXACT;
}
exports.leastPrecise = leastPrecise;
//# sourceMappingURL=CountPrecisionUtil.js.map